//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

export function getMonitoringFormConfigs(studyId?: number | undefined, formIds?: number[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.MonitoringFormConfigDto[]> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/configs?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (formIds !== undefined && formIds !== null)
        formIds && formIds.forEach(item => { url_ += "formIds=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMonitoringFormConfigs,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMonitoringFormConfigs(_response);
    });
}

function processGetMonitoringFormConfigs(response: AxiosResponse): Promise<Types.MonitoringFormConfigDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.MonitoringFormConfigDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.MonitoringFormConfigDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MonitoringFormConfigDto[]>(null as any);
}

export function createMonitoringFormsConfig(dto: Types.MonitoringFormConfigCreationDto, studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.MonitoringFormConfigDto> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/configs?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateMonitoringFormsConfig,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateMonitoringFormsConfig(_response);
    });
}

function processCreateMonitoringFormsConfig(response: AxiosResponse): Promise<Types.MonitoringFormConfigDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.MonitoringFormConfigDto.fromJS(resultData200);
        return Promise.resolve<Types.MonitoringFormConfigDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MonitoringFormConfigDto>(null as any);
}

export function getMonitoringFormConfig(formId: number, config?: AxiosRequestConfig | undefined): Promise<Types.MonitoringFormConfigDto> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/configs/{formId}";
    if (formId === undefined || formId === null)
      throw new Error("The parameter 'formId' must be defined.");
    url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMonitoringFormConfig,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMonitoringFormConfig(_response);
    });
}

function processGetMonitoringFormConfig(response: AxiosResponse): Promise<Types.MonitoringFormConfigDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.MonitoringFormConfigDto.fromJS(resultData200);
        return Promise.resolve<Types.MonitoringFormConfigDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MonitoringFormConfigDto>(null as any);
}

export function patchMonitoringFormsConfig(formId: number, dto: Types.MonitoringFormConfigPatchingDto, config?: AxiosRequestConfig | undefined): Promise<Types.MonitoringFormConfigDto> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/configs/{formId}";
    if (formId === undefined || formId === null)
      throw new Error("The parameter 'formId' must be defined.");
    url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchMonitoringFormsConfig,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchMonitoringFormsConfig(_response);
    });
}

function processPatchMonitoringFormsConfig(response: AxiosResponse): Promise<Types.MonitoringFormConfigDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.MonitoringFormConfigDto.fromJS(resultData200);
        return Promise.resolve<Types.MonitoringFormConfigDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MonitoringFormConfigDto>(null as any);
}

export function removeMonitoringFormsConfig(formId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/configs/{formId}";
    if (formId === undefined || formId === null)
      throw new Error("The parameter 'formId' must be defined.");
    url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveMonitoringFormsConfig,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveMonitoringFormsConfig(_response);
    });
}

function processRemoveMonitoringFormsConfig(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function getMonitoringFormResults(formId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.MonitoringFormResultDto[]> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results?";
    if (formId === null)
        throw new Error("The parameter 'formId' cannot be null.");
    else if (formId !== undefined)
        url_ += "formId=" + encodeURIComponent("" + formId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMonitoringFormResults,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMonitoringFormResults(_response);
    });
}

function processGetMonitoringFormResults(response: AxiosResponse): Promise<Types.MonitoringFormResultDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.MonitoringFormResultDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.MonitoringFormResultDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MonitoringFormResultDto[]>(null as any);
}

export function processNewMonitoringFormResult(dto: Types.MonitoringFormProcessingDto, formId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results?";
    if (formId === null)
        throw new Error("The parameter 'formId' cannot be null.");
    else if (formId !== undefined)
        url_ += "formId=" + encodeURIComponent("" + formId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigProcessNewMonitoringFormResult,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processProcessNewMonitoringFormResult(_response);
    });
}

function processProcessNewMonitoringFormResult(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function getMonitoringFormResultsForList(formId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ShortMonitoringFormResultDto[]> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results/forList?";
    if (formId === null)
        throw new Error("The parameter 'formId' cannot be null.");
    else if (formId !== undefined)
        url_ += "formId=" + encodeURIComponent("" + formId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMonitoringFormResultsForList,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMonitoringFormResultsForList(_response);
    });
}

function processGetMonitoringFormResultsForList(response: AxiosResponse): Promise<Types.ShortMonitoringFormResultDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.ShortMonitoringFormResultDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.ShortMonitoringFormResultDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ShortMonitoringFormResultDto[]>(null as any);
}

export function getMonitoringFormResult(resultId: number, config?: AxiosRequestConfig | undefined): Promise<Types.MonitoringFormResultDto> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results/{resultId}";
    if (resultId === undefined || resultId === null)
      throw new Error("The parameter 'resultId' must be defined.");
    url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMonitoringFormResult,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMonitoringFormResult(_response);
    });
}

function processGetMonitoringFormResult(response: AxiosResponse): Promise<Types.MonitoringFormResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.MonitoringFormResultDto.fromJS(resultData200);
        return Promise.resolve<Types.MonitoringFormResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MonitoringFormResultDto>(null as any);
}

export function removeMonitoringFormResult(resultId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results/{resultId}";
    if (resultId === undefined || resultId === null)
      throw new Error("The parameter 'resultId' must be defined.");
    url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveMonitoringFormResult,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveMonitoringFormResult(_response);
    });
}

function processRemoveMonitoringFormResult(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function processNewMonitoringFormResultVersion(resultId: number, dto: Types.MonitoringFormProcessingDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results/{resultId}/versions";
    if (resultId === undefined || resultId === null)
      throw new Error("The parameter 'resultId' must be defined.");
    url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigProcessNewMonitoringFormResultVersion,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processProcessNewMonitoringFormResultVersion(_response);
    });
}

function processProcessNewMonitoringFormResultVersion(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function uploadConfigFile(studyId?: number | undefined, file?: Types.FileParameter | null | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/files/config/upload?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUploadConfigFile,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUploadConfigFile(_response);
    });
}

function processUploadConfigFile(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function uploadResultFile(studyId?: number | undefined, file?: Types.FileParameter | null | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/configurableMonitoringForms/files/results/upload?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUploadResultFile,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUploadResultFile(_response);
    });
}

function processUploadResultFile(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}
let _requestConfigGetMonitoringFormConfigs: Partial<AxiosRequestConfig> | null;
export function getGetMonitoringFormConfigsRequestConfig() {
  return _requestConfigGetMonitoringFormConfigs;
}
export function setGetMonitoringFormConfigsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringFormConfigs = value;
}
export function patchGetMonitoringFormConfigsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringFormConfigs = patch(_requestConfigGetMonitoringFormConfigs ?? {});
}

let _requestConfigCreateMonitoringFormsConfig: Partial<AxiosRequestConfig> | null;
export function getCreateMonitoringFormsConfigRequestConfig() {
  return _requestConfigCreateMonitoringFormsConfig;
}
export function setCreateMonitoringFormsConfigRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateMonitoringFormsConfig = value;
}
export function patchCreateMonitoringFormsConfigRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateMonitoringFormsConfig = patch(_requestConfigCreateMonitoringFormsConfig ?? {});
}

let _requestConfigGetMonitoringFormConfig: Partial<AxiosRequestConfig> | null;
export function getGetMonitoringFormConfigRequestConfig() {
  return _requestConfigGetMonitoringFormConfig;
}
export function setGetMonitoringFormConfigRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringFormConfig = value;
}
export function patchGetMonitoringFormConfigRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringFormConfig = patch(_requestConfigGetMonitoringFormConfig ?? {});
}

let _requestConfigPatchMonitoringFormsConfig: Partial<AxiosRequestConfig> | null;
export function getPatchMonitoringFormsConfigRequestConfig() {
  return _requestConfigPatchMonitoringFormsConfig;
}
export function setPatchMonitoringFormsConfigRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchMonitoringFormsConfig = value;
}
export function patchPatchMonitoringFormsConfigRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchMonitoringFormsConfig = patch(_requestConfigPatchMonitoringFormsConfig ?? {});
}

let _requestConfigRemoveMonitoringFormsConfig: Partial<AxiosRequestConfig> | null;
export function getRemoveMonitoringFormsConfigRequestConfig() {
  return _requestConfigRemoveMonitoringFormsConfig;
}
export function setRemoveMonitoringFormsConfigRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveMonitoringFormsConfig = value;
}
export function patchRemoveMonitoringFormsConfigRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveMonitoringFormsConfig = patch(_requestConfigRemoveMonitoringFormsConfig ?? {});
}

let _requestConfigGetMonitoringFormResults: Partial<AxiosRequestConfig> | null;
export function getGetMonitoringFormResultsRequestConfig() {
  return _requestConfigGetMonitoringFormResults;
}
export function setGetMonitoringFormResultsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringFormResults = value;
}
export function patchGetMonitoringFormResultsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringFormResults = patch(_requestConfigGetMonitoringFormResults ?? {});
}

let _requestConfigProcessNewMonitoringFormResult: Partial<AxiosRequestConfig> | null;
export function getProcessNewMonitoringFormResultRequestConfig() {
  return _requestConfigProcessNewMonitoringFormResult;
}
export function setProcessNewMonitoringFormResultRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigProcessNewMonitoringFormResult = value;
}
export function patchProcessNewMonitoringFormResultRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigProcessNewMonitoringFormResult = patch(_requestConfigProcessNewMonitoringFormResult ?? {});
}

let _requestConfigGetMonitoringFormResultsForList: Partial<AxiosRequestConfig> | null;
export function getGetMonitoringFormResultsForListRequestConfig() {
  return _requestConfigGetMonitoringFormResultsForList;
}
export function setGetMonitoringFormResultsForListRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringFormResultsForList = value;
}
export function patchGetMonitoringFormResultsForListRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringFormResultsForList = patch(_requestConfigGetMonitoringFormResultsForList ?? {});
}

let _requestConfigGetMonitoringFormResult: Partial<AxiosRequestConfig> | null;
export function getGetMonitoringFormResultRequestConfig() {
  return _requestConfigGetMonitoringFormResult;
}
export function setGetMonitoringFormResultRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringFormResult = value;
}
export function patchGetMonitoringFormResultRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringFormResult = patch(_requestConfigGetMonitoringFormResult ?? {});
}

let _requestConfigRemoveMonitoringFormResult: Partial<AxiosRequestConfig> | null;
export function getRemoveMonitoringFormResultRequestConfig() {
  return _requestConfigRemoveMonitoringFormResult;
}
export function setRemoveMonitoringFormResultRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveMonitoringFormResult = value;
}
export function patchRemoveMonitoringFormResultRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveMonitoringFormResult = patch(_requestConfigRemoveMonitoringFormResult ?? {});
}

let _requestConfigProcessNewMonitoringFormResultVersion: Partial<AxiosRequestConfig> | null;
export function getProcessNewMonitoringFormResultVersionRequestConfig() {
  return _requestConfigProcessNewMonitoringFormResultVersion;
}
export function setProcessNewMonitoringFormResultVersionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigProcessNewMonitoringFormResultVersion = value;
}
export function patchProcessNewMonitoringFormResultVersionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigProcessNewMonitoringFormResultVersion = patch(_requestConfigProcessNewMonitoringFormResultVersion ?? {});
}

let _requestConfigUploadConfigFile: Partial<AxiosRequestConfig> | null;
export function getUploadConfigFileRequestConfig() {
  return _requestConfigUploadConfigFile;
}
export function setUploadConfigFileRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUploadConfigFile = value;
}
export function patchUploadConfigFileRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUploadConfigFile = patch(_requestConfigUploadConfigFile ?? {});
}

let _requestConfigUploadResultFile: Partial<AxiosRequestConfig> | null;
export function getUploadResultFileRequestConfig() {
  return _requestConfigUploadResultFile;
}
export function setUploadResultFileRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUploadResultFile = value;
}
export function patchUploadResultFileRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUploadResultFile = patch(_requestConfigUploadResultFile ?? {});
}